import { render, staticRenderFns } from "./LoadData.vue?vue&type=template&id=26624e9c"
import script from "./LoadData.js?vue&type=script&lang=js&external"
export * from "./LoadData.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports